<template>
  <div />
</template>

<style>
.card-body-link {
  color: var(--ASU-grayscale-Gray-1, #191919);
  /* Body text/Body | Default */
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
</style>
